import { Navigate, Outlet } from "react-router";
import { useAuth } from "../providers/AuthenticationProvider";

const TraderProtection = () => {
	const { user } = useAuth();

	if (user == null || user.uid == "") {
		return <Navigate to="/login" />;
	}

	return <Outlet />;
};

export default TraderProtection;
